<template>
  <div class="radius-12 bg-white box-shadow-light-aff border-semi-grey">
    <div class="row" :class="is_addt_srv ? 'slim-grid-row' : 'no-gutters'">
      <div class="col-12" :class="{
        'col-md-3': !is_addt_srv
      }">
        <div 
          v-if="data.image_list.length > 1"
          class="w-100 card-product-height position-relative overflow-hidden" 
          :class="window_width < 768 || is_addt_srv ? 'radius-12-t' : 'radius-12-l'"
          >
          <flickity class="spa-product" ref="slider_list" :options="slider_option">
            <div class="carousel-cell w-100" :id="slider_merchant.id"
              v-for="(slider_merchant,index) in  data.image_list">
              <div class="w-100 card-product-height">
                <img @click="toggleDetail()" :src="slider_merchant.image_url" class="img-fit"
                  :alt="data.name">
              </div>
            </div>
          </flickity>
          <div class="concierge-slider-btn right" @click="clickButtonSlider('slider_list','next')">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="11" cy="11" r="10.5" transform="rotate(-180 11 11)" fill="white" stroke="#D9D9D9" />
              <path
                d="M13.4816 10.9821C13.4816 10.861 13.4331 10.7398 13.341 10.6574L9.49796 6.9064C9.41557 6.82402 9.30895 6.77556 9.18779 6.77556C8.93579 6.77556 8.74194 6.96459 8.74194 7.21657C8.74194 7.33773 8.7904 7.44919 8.86794 7.53161L12.6626 11.2438V10.7253L8.86794 14.4375C8.7904 14.5151 8.74194 14.6265 8.74194 14.7525C8.74194 15.0045 8.93579 15.1935 9.18779 15.1935C9.30895 15.1935 9.41557 15.1451 9.5028 15.0627L13.341 11.3117C13.4331 11.2196 13.4816 11.1081 13.4816 10.9821Z"
                fill="black" fill-opacity="0.85" />
            </svg>
          </div>
          <div class="concierge-slider-btn left" @click="clickButtonSlider('slider_list','previous')">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="11" cy="11" r="10.5" fill="white" stroke="#D9D9D9" />
              <path
                d="M8.5184 11.0179C8.5184 11.139 8.56687 11.2602 8.65896 11.3426L12.502 15.0936C12.5844 15.176 12.6911 15.2244 12.8122 15.2244C13.0642 15.2244 13.2581 15.0354 13.2581 14.7834C13.2581 14.6623 13.2096 14.5508 13.1321 14.4684L9.33743 10.7562V11.2747L13.1321 7.56247C13.2096 7.48493 13.2581 7.37347 13.2581 7.24747C13.2581 6.99546 13.0642 6.80646 12.8122 6.80646C12.6911 6.80646 12.5844 6.85492 12.4972 6.93731L8.65896 10.6883C8.56687 10.7804 8.5184 10.8919 8.5184 11.0179Z"
                fill="black" fill-opacity="0.85" />
            </svg>
          </div>
        </div>
        <div class="w-100 card-product-height" @click="toggleDetail()" v-else>
          <img v-if="data.image_list.length == 1" :src="data.image_list[0].image_url"
            class="img-fit cursor-pointer" :alt="data.name" :class="window_width < 768 || is_addt_srv ? 'radius-12-t' : 'radius-12-l'">
          <img v-else :src="data.image_url" class="img-fit cursor-pointer" :alt="data.name" :class="window_width < 768 || is_addt_srv ? 'radius-12-t' : 'radius-12-l'">
        </div>
      </div>
      <div class="col-12" :class="{
        'col-md-9': !is_addt_srv
      }">
        <div class="row no-gutters">
          <div class="col-12 border-r-semi-grey"
            :class="{
              'col-sm-8': !is_addt_srv
            }">
            <div class="p-3 position-relative" :class="is_addt_srv ? 'card-product-height-smaller' : 'card-product-height'">
              <p class="mb-2 sub-heading-1-2">{{ data.name }}</p>
              <p class="mb-0 body-2-2-1 text-truncate-3" v-if="!is_addt_srv">{{ data.description }}</p>
              <div class="w-100 position-absolute px-3" style="bottom: 16px;left: 0px;">
                <div class="row">
                  <div class="col-8 align-self-end">
                    <ul class="pl-3">
                      <li class="mb-1" v-if="data.duration_type != 'NO_SHOW' && duration != ''">
                        <p class="mb-0 body-2-4 responsive">
                          {{ duration }}</p>
                      </li>
                      <li v-if="data.policy != null">
                        <p class="mb-0 body-2-4 responsive text-truncate">{{ data.policy.name }}</p>
                      </li>
                    </ul>
                  </div>
                  <div class="col-4 align-self-end text-right">
                    <p class="overline mb-0 text-green cursor-pointer text-uppercase underline"
                      @click="toggleDetail()">View Details</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div 
            class="col-12 text-left"
            :class="{
              'col-sm-4 text-sm-right': !is_addt_srv
            }" >
            <div class="pr-3 py-3 w-100 pl-3" :class="{
              'card-product-height pl-sm-0' : window_width >= 576 && !is_addt_srv,
              
            }">
              <div class="row" :class="is_addt_srv ? 'align-items-end' : 'align-items-center'">
                <div :class="!is_addt_srv ? 'col-sm-12 col-7' : 'col-7 card-price-height'">
                  <div class="w-100" :class="window_width >= 576 && !is_addt_srv ? 'mb-3' : ''">
                    <p class="body-3-3-1 mb-1">Starting from</p>
                    <template v-if="!is_addt_srv || (is_addt_srv && window_width < 1500)">
                      <p class="mb-0 body-2 text-line-through" v-if="data.price.promotion_pct > 0">{{ $formatCurrency(data.price.price_sell_base) }}</p>
                      <p class="mb-1 text-20 text-orange font-lato lh-1">{{ $formatCurrency(final_price) }}</p>
                    </template>
                    <div v-else class="d-flex">
                      <p class="mb-1 mr-2 text-20 text-orange font-lato lh-1">{{ $formatCurrency(final_price) }}</p>
                      <p class="mb-0 body-2 text-line-through" v-if="data.price.promotion_pct > 0">{{ $formatCurrency(data.price.price_sell_base) }}</p>
                    </div>
                    <p class="body-3-3-1 mb-0" v-if="data.guest_include > 0">/ {{ guest_included }}</p>
                  </div>
                </div>
                <div v-if="(window_width < 576 && !is_addt_srv) || is_addt_srv" class="col-5 text-right">
                  <button class="g-btn g-btn-md g-btn-secondary px-4" @click="toggleDetail()">Book Now</button>
                </div>
              </div>
              <div v-if="window_width >= 576 && !is_addt_srv" class="w-100 position-absolute px-3 text-right" style="bottom: 16px;left: 0px;">
                <button class="g-btn g-btn-md g-btn-secondary px-4" @click="toggleDetail()">Book Now</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal 
      v-model="detail_product.show" 
      ref="product_detail" 
      centered size="xl" hide-footer hide-header
      no-close-on-backdrop no-close-on-esc body-class="p-0">
      <ProductDetail 
        :data="data" 
        :general_data="general_data"
        :page_source="page_module"
        :window_width="window_width"
        @close="toggleDetail()">
      </ProductDetail>
    </b-modal>
  </div>
</template>

<script>
  import DateRangePicker from 'vue2-daterange-picker';
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
  import ProductSliderDetail from './ProductSliderDetail';
  import ProductDetail from './ProductDetail';

  export default {
    // props: ['data', 'general_data', 'window_width'],
    props:{
      data:{
        type: Object,
        default: () => {}
      },
      general_data:{
        type: Object,
        default: () => {}
      },
      page_module:{
        type: String,
        default: 'general'
      }
    },
    components: {
      DateRangePicker,
      ProductSliderDetail,
      ProductDetail
    },
    data() {
      return {
        slider_option: {
          initialIndex: 0,
          autoPlay: 5000,
          prevNextButtons: false,
          pageDots: true,
          adaptiveHeight: false,
          wrapAround: true,
        },
        detail_product: {
          show: false,
          key: 0
        },
        window_width: window.innerWidth
      }
    },
    computed: {
      is_addt_srv(){
        return this.page_module == 'additional_service' ? true : false
      },
      guest_included() {
        if (this.data.guest_include == 1) return `per person`
        return `per ${this.data.guest_include} people`
      },
      tax_service() {
        let ts = this.data.tax_services
        if (ts) {
          if (ts.calculation_type == 'INCLUDE') return 'Includes taxes and services'
          return 'Excludes taxes and service'
        } else {
          return ''
        }
      },
      final_price(){
        return this.data.price.price_sell_base - (this.data.price.price_sell_base*(Math.round(this.data.price.promotion_pct)/100))
      },
      duration(){
        if(!this.$isNotEmpty(this.data.duration_text)) return ''
        else{
          let text = this.data.duration_text
          if(this.data.duration_type == 'HOUR' || this.data.duration_type == 'MINUTE'){
            let unit = this.data.duration_type == 'HOUR' ? 'Hour(s)' : 'Minute(s)'
            text += ` ${unit}`
          }
          return text
        }
      }
    },
    mounted(){
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResizeWindow);
      })
    },
    methods: {
      onResizeWindow(){
        this.window_width = window.innerWidth
      },
      toggleDetail() {
        this.detail_product.show = !this.detail_product.show
        if(this.detail_product.show) this.$refs.product_detail.hide()
        else this.$refs.product_detail.show()
      },
      clickButtonSlider(refname, type) {
        if (type == 'next') this.$refs[refname].next()
        else this.$refs[refname].previous()
      }
    }
  }

</script>
<style>
  .card-product-height {
    height: 200px;
  }
  .card-product-height-smaller {
    height: 120px;
  }
  .card-price-height{
    height: 85px;
    display: grid;
    place-items: end;
  }

  .bottom-0 {
    bottom: 0 !important;
  }

  .spa-select {
    padding: 10px 15px;
    border: 1px solid #CCC;
    border-radius: 6px;
    cursor: pointer;
  }

  .spa-select.active {
    color: #fff;
    border-color: var(--merchant-button-color);
    background-color: var(--merchant-button-color);
  }

  .height-animated {
    height: 0px;
    max-height: 0px;
    transition: max-height 0.3s;
    overflow: hidden;
  }

  .height-animated.active {
    height: auto;
    max-height: 1000px;
  }

</style>



// WEBPACK FOOTER //
// src/components/hotel/concierge/activity/Product.vue